import toast from 'react-hot-toast';
import api from "../Crypto/axios.js";

export const FETCH_USER = 'FETCH_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const FETCH_COUNTS = 'FETCH_COUNTS';
export const RESET_FETCH_COUNTS = 'RESET_FETCH_COUNTS';

const initialState = {
  userDetails: {},
  dataCounts: {},
};

const UsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER:
      return {
        ...state,
        userDetails: action.payload,
      };
    case FETCH_COUNTS:
      return {
        ...state,
        dataCounts: action.payload,
      };
    case RESET_FETCH_COUNTS:
      return {
        ...state,
        dataCounts: {},
      };
    default:
      return state;
  }
};

export default UsersReducer;

export const fetchUser = (data) => ({
  type: FETCH_USER,
  payload: data,
});

export const fetchCount = (data) => ({
  type: FETCH_COUNTS,
  payload: data,
});

export const resetCount = () => ({
  type: RESET_FETCH_COUNTS,
});

export const fetchUserDetails = (userId) => {
  return async (dispatch) => {
    try {
      const response = await api.get(`/nrcb/ecom/userinfo/get/${userId}`, {
        requiresAuth: true,
      });
      dispatch(fetchUser(response));
      return response;
    } catch (error) {
      return {
        status: 'error',
        message: error?.message || 'Failed to fetch user details',
      };
    }
  };
};

export const updateUserDetails = (userId, updatedData) => {
  return async (dispatch) => {
    const promise = api
      .post(`/nrcb/ecom/update/user/${userId}`, updatedData, {
        requiresAuth: true,
      })
      .then((response) => {
        dispatch(fetchUserDetails(userId));
        return response;
      })
      .catch((error) => {
        console.error('Failed to update user details:', error);
        throw new Error(error.message || 'Failed to update user details');
      });

    toast.promise(promise, {
      loading: 'Updating user...',
      success: 'User details updated successfully',
      error: (error) => error.message || 'Failed to update user details',
    });

    return promise;
  };
};

export const resetPassword = (userId, passData) => {
  return async (dispatch) => {
    const promise = api
      .post(`/nrcb/ecom/pass/reset/${userId}`, passData, { requiresAuth: true })
      .then((response) => {
        dispatch(fetchUserDetails(userId));
        return response;
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.message;

        if (error.response?.status === 400) {
          if (
            errorMessage === 'New password and confirm password do not match'
          ) {
            toast.error('New password and confirm password do not match');
          } else if (errorMessage === 'Current password is incorrect') {
            toast.error('Current password is incorrect');
          } else {
            toast.error('Invalid user data');
          }
        } else {
          console.error('Failed to update password:', error);
        }

        throw error;
      });

    toast.promise(promise, {
      loading: 'Updating password...',
      success: () => 'Password updated successfully',
      error: (error) =>
        error?.response?.status === 400
          ? ''
          : error.message || 'Failed to update password',
    });

    return promise;
  };
};

export const fetchDataCounts = (adminId) => {
  return async (dispatch) => {
    try {
      const response = await api.post(
        `/nrcb/ecom/count/${adminId}`,
        {},
        { requiresAuth: true }
      );
      dispatch(fetchCount(response));
      return response;
    } catch (error) {
      console.error('Failed to fetch products:', error);
      return { status: 'error', message: error.message };
    }
  };
};

